/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import moment from 'moment';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import {
  getAccountDrawerOrdersCacheTTL,
  getOrderHistoryExtended,
  getOrderHistoryExtendedPageSize,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import constants from '../Orders.constants';
import {
  setOrdersList,
  setChangedSiteId,
  showLoader,
  hideLoader,
  hideLoadMore,
  showLoadMore,
  setDeliveredOrderIds,
  showCTLLoader,
  hideCTLLoader,
  showAccountDrawerOrdersLoader,
  hideAccountDrawerOrdersLoader,
  setAccountDrawerOrdersList,
  setOrdersListForStore,
  setNewLoader,
  setFilterOptions,
  setOrderError,
} from './Orders.actions';
import {
  getOrderFilterOptions,
  getOrdersState,
  getSelectedYear,
  getCompanyId,
} from './Orders.selectors';
import {
  getOrderHistory,
  getDeliveredOrderHistory,
  getExtendedOrderHistory,
} from '../../../../../services/abstractors/account/ordersList';
import { getPlaceSiteId } from '../../../../../utils';
import { setGlobalError } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

export const getUpdatedSiteId = (currentSiteId) => {
  return currentSiteId ? `PLACE_${currentSiteId.toUpperCase()}` : getPlaceSiteId();
};

export const formatArray = (array) => {
  const reversedArray = array?.slice()?.reverse();
  return reversedArray?.filter((obj, index) => {
    return (
      index ===
      reversedArray?.findIndex((item) => {
        return item?.orderNumber === obj?.orderNumber;
      })
    );
  });
};

const getFilteredData = (ordersListItems, selectedYear) => {
  const startDate = moment(selectedYear?.startDate).utc().format();
  const endDate = moment(selectedYear?.endDate).utc().format();
  return ordersListItems?.filter((item) => {
    const date = moment(item?.orderDateWithoutFormatting?.toString(), 'LL').utc().format();
    if (selectedYear?.pastOrder) {
      if (date >= startDate && date <= endDate) {
        if (item?.isPastOrder) {
          return item;
        }
        return null;
      }
    } else if (date >= startDate && date <= endDate) {
      return item;
    }
    return null;
  });
};

export const condForLoadMore = ({
  reqParams,
  orders,
  orderPageSize,
  orderPageNum,
  pastOrders,
  pastOrder,
  fromDidMount,
  selectedYear,
  tempArray,
  extendOrderHistorySwitch,
  pageSizeForExtendOrders,
}) => {
  const ordersArray = fromDidMount ? tempArray : orders?.orders;
  const pageSize = pastOrders ? pageSizeForExtendOrders : orderPageSize;
  const filterdata = getFilteredData(ordersArray, selectedYear);
  const totalRecords =
    pastOrder && fromDidMount ? Number(pastOrders.totalRecords) : Number(orders.totalRecords);
  return (
    reqParams.itemdetails &&
    (orders && totalRecords) > Number(pageSize) * (Number(orderPageNum) + 1) &&
    !(extendOrderHistorySwitch && filterdata?.length === 0)
  );
};

/**
 * @function getMyOrders
 * @description This function will call getOrderHistory Abstractor to get order history data
 */

export function* getMyOrders({ payload }) {
  yield put(setOrderError(null));
  yield put(setNewLoader(true));
  const {
    fromLoadMore,
    loadMoreCallback,
    siteId,
    currentSiteId,
    isFromStore,
    reqParams = {},
    accountOrdersAPISwitch = false,
    fromDidMount,
    fromDropDown,
    fromCountrySwitch,
  } = payload;
  const orderPageSize = reqParams.pageSize || constants.ORDER_SIZE;
  const orderPageNum = reqParams.pageNumber || 0;
  try {
    const { accountDrawer, pastOrder } = reqParams;
    if (!accountDrawer) {
      yield put(showLoader());
    }
    const extendOrderHistorySwitch = yield select(getOrderHistoryExtended);
    const pageSizeForExtendOrders = yield select(getOrderHistoryExtendedPageSize);
    let orders;
    let pastOrders;
    let tempArray = [];
    const ordersData1 = yield select(getOrdersState);
    if (fromDropDown || fromDidMount) {
      const newArray = ordersData1?.filter((item) => {
        return !item.isPastOrder;
      });

      if (fromCountrySwitch) {
        yield put(setOrdersList({}));
      } else {
        yield put(
          setOrdersList({
            totalPages: 0,
            orders: newArray,
          })
        );
      }
    }
    if (!fromDidMount) {
      orders =
        extendOrderHistorySwitch && pastOrder
          ? yield call(
              getExtendedOrderHistory,
              siteId,
              currentSiteId,
              reqParams,
              pageSizeForExtendOrders,
              extendOrderHistorySwitch
            )
          : yield call(getOrderHistory, siteId, currentSiteId, reqParams, accountOrdersAPISwitch);
    }
    if (fromDidMount && extendOrderHistorySwitch) {
      orders = yield call(
        getOrderHistory,
        siteId,
        currentSiteId,
        reqParams,
        accountOrdersAPISwitch
      );

      pastOrders = yield call(
        getExtendedOrderHistory,
        siteId,
        currentSiteId,
        reqParams,
        pageSizeForExtendOrders,
        extendOrderHistorySwitch
      );
      tempArray = [...orders?.orders, ...pastOrders?.orders];
    }
    const siteIdFromStore = yield select(getCompanyId);
    const updateCurrentSiteId = currentSiteId || siteIdFromStore;
    const updateChangedSiteId = getUpdatedSiteId(updateCurrentSiteId);
    yield put(setChangedSiteId(updateChangedSiteId));
    const selectedYear = yield select(getSelectedYear);
    const orderFilterOptions = yield select(getOrderFilterOptions);

    if (
      condForLoadMore({
        reqParams,
        orders,
        orderPageSize,
        orderPageNum,
        pastOrders,
        pastOrder,
        fromDidMount,
        selectedYear,
        tempArray,
        extendOrderHistorySwitch,
        pageSizeForExtendOrders,
      })
    ) {
      const newObj = { ...selectedYear };
      const newArray = orderFilterOptions?.map((obj) => {
        if (obj?.id === newObj?.id) {
          return {
            ...obj,
            showLoadMore: true,
          };
        }
        return obj;
      });
      yield put(setFilterOptions(newArray));
      yield put(showLoadMore());
    } else {
      const newObj = { ...selectedYear };
      const newArray = orderFilterOptions?.map((obj) => {
        if (obj?.id === newObj?.id) {
          return {
            ...obj,
            showLoadMore: false,
          };
        }
        return obj;
      });
      yield put(setFilterOptions(newArray));
      yield put(hideLoadMore());
    }
    if (!selectedYear?.pastOrder || fromDidMount) {
      const newArray1 = orderFilterOptions?.map((obj, index) => {
        if (index === 0) {
          return {
            ...obj,
            initialFetch: orders?.initialFetch,
          };
        }
        return obj;
      });
      yield put(setFilterOptions(newArray1));
    }

    if (fromLoadMore) {
      let ordersData = yield select(getOrdersState);

      if (!ordersData) {
        ordersData = [];
      }
      ordersData = fromDidMount ? ordersData.concat(tempArray) : ordersData?.concat(orders.orders);
      const formatedData = formatArray(ordersData);
      const reversedFormattedArray = formatedData?.slice()?.reverse();
      yield put(
        setOrdersList({
          totalPages: orders?.totalPages,
          orders: reversedFormattedArray,
        })
      );
    } else if (isFromStore) {
      yield put(setOrdersListForStore(orders));
    } else {
      yield put(setOrdersList(orders));
    }
    if (loadMoreCallback) {
      loadMoreCallback();
    }
  } catch (e) {
    const errObj = {
      message: getDynamicLabelValues('dynamic.error_messages.lbl_ORDERS_GENERIC_ERROR'),
      type: 'error',
    };
    yield put(setOrderError(errObj));
    yield put(setGlobalError(errObj));
    logger.error(constants.LOGGER_ERROR_MESSAGE, {
      error: e,
      extraData: {
        component: 'Orders Saga - getMyOrders',
        payloadRecieved: payload,
      },
    });
  } finally {
    yield put(hideLoader());
    yield put(setNewLoader(false));
  }
}

export function* getDeliveredOrderIds({ payload }) {
  const { siteId, currentSiteId, reqParams = {}, accountOrdersAPISwitch = false } = payload;
  try {
    const { accountDrawer } = reqParams;
    if (!accountDrawer) {
      yield put(showCTLLoader());
    }

    const orders = yield call(
      getDeliveredOrderHistory,
      siteId,
      currentSiteId,
      reqParams,
      accountOrdersAPISwitch
    );

    yield put(setDeliveredOrderIds(orders));
  } catch (e) {
    logger.error(constants.LOGGER_ERROR_MESSAGE, {
      error: e,
      extraData: {
        component: 'Orders Saga - getMyOrders',
        payloadRecieved: payload,
      },
    });
  } finally {
    yield put(hideCTLLoader());
  }
}

export function* getAccountDrawerMyOrders({ payload }) {
  const { siteId, currentSiteId, reqParams = {}, accountOrdersAPISwitch = false } = payload;
  try {
    yield put(showAccountDrawerOrdersLoader());

    const orders = yield call(
      getOrderHistory,
      siteId,
      currentSiteId,
      reqParams,
      accountOrdersAPISwitch
    );

    const updateChangedSiteId = currentSiteId
      ? `PLACE_${currentSiteId.toUpperCase()}`
      : getPlaceSiteId();
    yield put(setChangedSiteId(updateChangedSiteId));
    const cacheTTL = yield select(getAccountDrawerOrdersCacheTTL);

    yield put(setAccountDrawerOrdersList({ orders, cacheTTL }));
  } catch (e) {
    logger.error(constants.LOGGER_ERROR_MESSAGE, {
      error: e,
      extraData: {
        component: 'Orders Saga - getAccountDrawerMyOrders',
        payloadRecieved: payload,
      },
    });
  } finally {
    yield put(hideAccountDrawerOrdersLoader());
  }
}

/**
 * @function OrdersSaga
 * @description watcher function for fetch orders.
 */
export function* OrdersSaga() {
  const cachedAccountDrawerMyOrders = validateReduxCache(getAccountDrawerMyOrders);
  yield takeLatest(constants.GET_ORDERS_LIST, getMyOrders);
  yield takeLatest(constants.GET_DELIVERED_ORDERS_LIST, getDeliveredOrderIds);
  yield takeLatest(constants.GET_ACCOUNT_DRAWER_ORDERS_LIST, cachedAccountDrawerMyOrders);
}

export default OrdersSaga;
